export default __webpack_public_path__ + "static/featuresListItem1-2217edbf6ddf0f58fa5e9d9838e16d12.svg";